// ** React Imports
import { useState, useEffect } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";

import {
  Grid,
  Typography,
  Divider,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import moment from "moment";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
const PatientsPaymentReport = (props) => {
  const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 0.5,
      bottom: params.isLastVisible ? 0 : 0.8,
    };
  }, []);
  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "white", // Use white or another valid color
    fontSize: "12px",
    color: "black",
    borderColor: "#326C1D",
    whiteSpace: "nowrap",

    "& .MuiDataGrid-root": {
      overflowX: "auto", // Enable horizontal scrolling
    },

    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#377562",
      color: "white",
      fontSize: "15px",
      fontWeight: "bold",
      textAlign: "center",
    },

    "& .MuiDataGrid-cell": {
      fontSize: "12px",
      textAlign: "left",
      overflow: "hidden",
      textOverflow: "ellipsis", // Prevents text overflow
      whiteSpace: "nowrap",
    },

    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637)",
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const [refresh, setRefresh] = useState(false);
  const [RemainingBalance, setRemainingBalance] = useState(0);
  const [OpenInfo, setOpenInfo] = useState(false); // Modal state
  const [ledgerDetails, setLedgerDetails] = useState([]); // API data
  const [dataType, setDataType] = useState(""); // "claim" or "era"

  const handleLedgerClick = async (row) => {
    try {
      let params = {};
      const url = `${process.env.REACT_APP_API_URL}/Patients/GetLedgerDetailsBySource`;

      // ✅ Map parameter based on Source
      switch (row.source) {
        case "INS Payment":
          params = { id: row.id };
          break;

        case "Patient Payment":
          params = { id: row.id };
          break;

        case "Claim":
        default:
          params = { id: row.id };
          break;
      }

      params.source = row.source;

      const response = await axios.get(url, { headers, params });

      setLedgerDetails(response);
      setOpenInfo(true);
      setDataType(row.source);
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "source",
      headerName: "Source",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 2,
      minWidth: 170,
      renderCell: (cellValues) => (
        <Button
          style={{ float: "left", marginLeft: "-15px" }}
          size="small"
          variant="text"
          color="info"
          onClick={() => handleLedgerClick(cellValues.row)}
        >
          {cellValues.row.source}
        </Button>
      ),
    },
       {
      field: "dos",
      headerName: "DOS",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      minWidth: 120,
         valueGetter: (params) =>
        params.value ? moment(params.value).format("MM-DD-YYYY") : "",
    },
    {
      field: "paymentType",
      headerName: "Payment Type",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      minWidth: 120,
    },
    {
      field: "code",
      headerName: "Code",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      minWidth: 120,
    },
    {
      field: "paidamount",
      headerName: "Paid amount",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 0.3,
    },
    {
      field: "allowamount",
      headerName: "Allow Amount",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 0.3,
    },
    {
      field: "adjustmentamount",
      headerName: "Adjustment amount",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 0.3,
    },
    {
      field: "balance",
      headerName: "Balance",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 0.3,
    },
    {
      field: "charges",
      headerName: "Charges",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 0.3,
    },
    {
      field: "writeoff",
      headerName: "Writeoff",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 110,
      flex: 0.3,
    },
    {
      field: "totalCharges",
      headerName: "Total Charges",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 0.3,
    },
  ];
  const patientId = props.patientId;
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Patients/patientPaymentReport?patId=${patientId}`,
        { headers }
      )
      .then((response) => {
        setLoading(false);
        // setRows(response)
        // setRemainingBalance(response.totalCharges)
        const data = response || [];
        const validCharges = data
          .filter((item) => item && typeof item.totalCharges === "number")
          .map((item) => item.totalCharges);
        const total = validCharges.reduce((acc, curr) => acc + curr, 0);
        setRemainingBalance(total);
        setRows(data);
      })
      .catch((error) => {});
  }, [refresh]);
const handleGenerateReport = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Patients/printPatientLedger?patientId=${patientId}`,
        {
          headers,
          responseType: "blob", // important for downloading files
        }
      );

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Patient_PaymentReport💵.pdf"); // download filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      Swal.fire({
        icon: "success",
        title: "Payment Report Generated!",
        text: "The PDF has been successfully generated and downloaded.",
               showConfirmButton: false,   
  timer: 1500,                
  timerProgressBar: true,
        timer: 4000,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } catch (error) {
      console.error("There was an error!", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while generating the Report. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Modal
        open={OpenInfo}
        onClose={() => setOpenInfo(false)}
        aria-labelledby="ledger-details-modal"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
          zIndex: 1800,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: { xs: "95%", sm: "90%", md: "75%", lg: "60%" },
            maxHeight: "85vh",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            overflowY: "auto",
          }}
        >
          {/* --- Header Section with Close Icon --- */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              borderBottom: "2px solid #1976d2",
              pb: 1,
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#1976d2", textAlign: "center", flexGrow: 1 }}
            >
              {dataType === "Claim"
                ? "Claim Details"
                : dataType === "Patient Payment"
                ? "Patient Payment Details"
                : "Insurance Payment Details"}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => setOpenInfo(false)}
              sx={{
                color: "#1976d2",
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* --- Table Section --- */}
          {ledgerDetails && ledgerDetails.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: "#f9fafb",
              }}
            >
              {ledgerDetails.map((item, index) => (
                <Paper
                  key={index}
                  elevation={2}
                  sx={{
                    p: 3,
                    borderRadius: 2,
                    backgroundColor: "white",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  }}
                >
                  <Grid container spacing={2}>
                    {dataType === "Claim" && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Date of Service:</strong>{" "}
                          {item.dos
                            ? moment(item.dos).format("MM-DD-YYYY")
                            : "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Insurance:</strong>{" "}
                          {item.insuranceName || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Status:</strong> {item.statusType || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Cpt Code 1:</strong> {item.cpt1 || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Cpt Code 2:</strong> {item.cpt2 || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Total Charges:</strong>{" "}
                          {item.totalCharges || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Amount Paid:</strong> {item.amountPaid || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Amount Due:</strong> {item.amountDue || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Amount Allowed:</strong>{" "}
                          {item.amountAllowed || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Write Off:</strong> {item.writeOff || "-"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Created On:</strong>{" "}
                          {item.createdDate
                            ? moment(item.createdDate).format("MM-DD-YYYY ")
                            : "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Updated On:</strong>{" "}
                          {item.updatedDate
                            ? moment(item.updatedDate).format("MM-DD-YYYY")
                            : "-"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Updated By:</strong> {item.updatedBy || "-"}
                        </Grid>
                      </>
                    )}

                    {/* ✅ PATIENT PAYMENT DETAILS */}
                    {dataType === "Patient Payment" && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Check No:</strong> {item.checkno || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Payer:</strong> {item.payer || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Check Amount:</strong>{" "}
                          {item.checkamount || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Check Date:</strong>{" "}
                          {item.checkdate
                            ? moment(item.checkdate).format("MM-DD-YYYY")
                            : "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Claim ID:</strong> {item.claimId || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Patient ID:</strong> {item.patientId || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Created On:</strong>{" "}
                          {item.createdDate
                            ? moment(item.createdDate).format(
                                "MM-DD-YYYY hh:mm A"
                              )
                            : "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Updated On:</strong>{" "}
                          {item.updatedDate
                            ? moment(item.updatedDate).format(
                                "MM-DD-YYYY hh:mm A"
                              )
                            : "-"}
                        </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                          <strong>Comments:</strong> {item.comments || "-"}
                        </Grid>
                      </>
                    )}

                    {/* ✅ INSURANCE PAYMENT DETAILS */}
                    {dataType === "INS Payment" && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Procedure Code:</strong> {item.code || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Payment Type:</strong>{" "}
                          {item.paymentType || "-"}
                        </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                          <strong>Payment Source:</strong>{" "}
                          {item.paymentSourse || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Charges:</strong> {item.charges || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Allow amount:</strong>{" "}
                          {item.allowamount || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Balance:</strong> {item.balance || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Paid Amount:</strong> {item.paidamount || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Adjustment:</strong>{" "}
                          {item.adjustmentamount || "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Units:</strong> {item.units || "-"}
                        </Grid>
                             <Grid item xs={12} sm={6} md={4}>
                          <strong>DOS To:</strong>{" "}
                          {item.dosTo
                            ? moment(item.dosTo).format("MM-DD-YYYY")
                            : "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Writeoff:</strong> {item.writeoff || "-"}
                        </Grid>
                         <Grid item xs={12} sm={6} md={4}>
                          <strong>Writeoff Reason:</strong> {item.writeOffReason || "-"}
                        </Grid>
                   
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Created On:</strong>{" "}
                          {item.createdDate
                            ? moment(item.createdDate).format("MM-DD-YYYY")
                            : "-"}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Updated On:</strong>{" "}
                          {item.updatedDate
                            ? moment(item.updatedDate).format("MM-DD-YYYY")
                            : "-"}
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Paper>
              ))}
            </Box>
          ) : (
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                color: "gray",
                fontStyle: "italic",
                py: 3,
              }}
            >
              No details found.
            </Typography>
          )}
        </Box>
      </Modal>

      <Box mb={3} marginTop={2}>
        {isLoading ? (
          <div style={{ margin: "5rem", textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div style={{ height: 400, width: "100%" }}>
            {rows === null || rows.length === 0 ? (
              <Typography>No Record found</Typography>
            ) : (
              <DataGrid
                rows={rows}
                getRowId={(row) => row.id}
                classes={gridClasses}
                rowHeight={20}
                columns={columns}
                getRowSpacing={getRowSpacing}

                //checkboxSelection
                fullWidth
                pagination
                autoPageSize
                sx={gridRowStyle}
              />
            )}
          </div>
        )}
        <Box display="flex" justifyContent="flex-end" mt={2}>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 3,
      width: "100%",
      maxWidth: 550,
      p: 2,
      borderRadius: "16px",
      background: "linear-gradient(135deg, #f8fffc 0%, #eef8f4 100%)",
      border: "1px solid rgba(55,117,98,0.2)",
      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    }}
  >
    <Button
      variant="contained"
      onClick={handleGenerateReport}
      disabled={isLoading}
      startIcon={!isLoading && <span>📄</span>}
      sx={{
        backgroundColor: "#377562",
        borderRadius: "12px",
        px: 3,
        py: 1.2,
        fontWeight: 600,
        textTransform: "none",
        minWidth: 180,
        boxShadow: "0 4px 12px rgba(55,117,98,0.3)",
        "&:hover": {
          backgroundColor: "#2d5f4f",
          transform: "translateY(-1px)",
        },
      }}
    >
      {isLoading ? (
        <>
          <CircularProgress
            size={18}
            color="inherit"
            sx={{ mr: 1 }}
          />
          Downloading...
        </>
      ) : (
        "Download Ledger"
      )}
    </Button>

    <Box textAlign="right">
      <Typography
        variant="body2"
        sx={{
          color: "#6b7280",
          fontWeight: 500,
        }}
      >
        Remaining Balance
      </Typography>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color:
            Number(props.Patientinfo?.toatalbalance) > 0
              ? "#d32f2f"
              : "#2e7d32",
        }}
      >
        $
        {Number(
          props.Patientinfo?.toatalbalance || 0
        ).toLocaleString()}
      </Typography>
    </Box>
  </Box>
</Box>
      </Box>
    </div>
  );
};

export default PatientsPaymentReport;
